// extracted by mini-css-extract-plugin
export default {"navbar_list":"Navbar_navbar_list__keIQ6","navbar_elem":"Navbar_navbar_elem__JMVYk","navbar_menu":"Navbar_navbar_menu__O7BLv","users_title":"Navbar_users_title__-2ngf"};